/*
|-------------------------------------------------------------------------------
| VUEX modules/bookings.js
|-------------------------------------------------------------------------------
| The Vuex data store for the cafes

status = 0 -> data hasn't been loaded
status = 1 -> data is loading
status = 2 -> data is loaded successfully
status = 3 -> data is loaded unsuccessfully
*/

import JourneyRequestTruckAPI from '../api/journeyRequestTruck.js';

export const journeyRequestsTruck = {
    namespaced: true,

    state: {
        journeyRequestTruckAddStatus: 0,

        journeyRequestsTruck: [],
        journeyRequestsTruckLoadStatus: 0,

        journeyRequestsTruckDeleteStatus: 0,

        showModal: false,
        journeyRequestTruck: {},
        journeyRequestTruckLoadStatus: 0,
    },

    actions: {
        load({commit}) {
            return new Promise((resolve, reject) => {
                commit('setLoadStatus', 1);

                JourneyRequestTruckAPI.index()
                    .then(response => {
                        commit('setJourneyRequests', response.data.data);
                        commit('setLoadStatus', 2);
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setJourneyRequests', []);
                        commit('setLoadStatus', 3);
                        reject(error);
                    });
            });
        },
        add({commit}, data){
            return new Promise((resolve, reject) => {
                commit('setAddStatus', 1);

                JourneyRequestTruckAPI.store(data)
                    .then(response => {
                        commit('setAddStatus', 2);
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setAddStatus', 3);
                        reject(error);
                    });
            });
        },
        show({commit}, id){
            return new Promise((resolve, reject) => {
                commit('setShowStatus', 1);

                JourneyRequestTruckAPI.show(id)
                    .then(response => {
                        commit('setJourneyRequest', response.data.data);
                        commit('setShowStatus', 2);
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setJourneyRequest', {});
                        commit('setShowStatus', 3);
                        reject(error);
                    });
            });
        },
        delete({commit, dispatch}, id){
            return new Promise((resolve, reject) => {
                commit('setDeleteStatus', 1);

                JourneyRequestTruckAPI.delete(id)
                    .then(response => {
                        dispatch('load');
                        commit('setDeleteStatus', 2);
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setDeleteStatus', 3);
                        reject(error);
                    });
            });
        },
        updateShowModal({commit}, value){
            commit( 'setShowModal', value );
        },
    },

    mutations: {
        setShowModal( state, value ){
            state.showModal = value;
        },
        setAddStatus( state, status ){
            state.journeyRequestTruckAddStatus = status;
        },
        setLoadStatus( state, status ){
            state.journeyRequestsTruckLoadStatus = status;
        },
        setJourneyRequests( state, requests ){
            state.journeyRequestsTruck = requests;
        },
        setDeleteStatus( state, status ){
            state.journeyRequestsTruckDeleteStatus = status;
        },
        setJourneyRequest( state, request ){
            state.journeyRequestTruck = request;
        },
        setShowStatus( state, status ){
            state.journeyRequestTruckLoadStatus = status;
        },
    },

    getters: {
        getJourneyRequests(state){
            return state.journeyRequestsTruck.map(journeyRequest => mapToRow(journeyRequest));
        },
        getJourneyRequest(state){
            if (Object.entries(state.journeyRequestTruck).length !== 0) {
                const row = mapToRow(state.journeyRequestTruck);
                const journeys = state.journeyRequestTruck.journeys.map(journey => mapToJourneyRow(journey));
                return Object.assign(row, {journeys: journeys});
            }
            return {};
        }
    },
};

/**
 * Helpers
 */
function mapToRow(raw) {
    return {
        id: raw.id,
        truckPlate: raw.truck_plate,
        startTime: moment(raw.start_time),
        endTime: moment(raw.end_time),
        processed: raw.processed,
    }
}

function mapToJourneyRow(journey) {
    let row = {
        id: journey.id,
        truck_plate: journey.truck_plate,
        truck_total_tare: journey.total_tare_weight,
        time_start: moment(journey.start_time).format('YYYY-MM-DD HH:mm:ss'),
        time_start_moment: moment(journey.start_time),
        time_end_moment: moment(journey.end_time),
        start_address: journey.start_address,
        end_address: journey.end_address,
        driver_tcp_quantity: journey.driver_tcp_quantity !== null? journey.driver_tcp_quantity : 'N/A',
    };
    if (journey.capacity_prediction !== null && journey.capacity_prediction.status === 1) {
        const boxWhiskerPrediction = {
            gvm: journey.capacity_prediction.gvm,
            payload_weight: journey.capacity_prediction.payload,
            tcp_quantity: journey.capacity_prediction.cages_quantity,
            available_tcp_quantity: journey.capacity_prediction.max_cages_quantity - journey.capacity_prediction.cages_quantity,
            payload_percentage: Math.round(journey.capacity_prediction.full_percentage / 10) * 10,
            method_name: journey.capacity_prediction.method_name,
        };
        Object.assign(row, boxWhiskerPrediction);
    } else {
        const boxWhiskerPrediction = {
            gvm: 'N/A',
            payload_weight: 'N/A',
            tcp_quantity: 'N/A',
            available_tcp_quantity: 'N/A',
            payload_percentage: 'N/A',
            method_name: 'N/A',
        };
        Object.assign(row, boxWhiskerPrediction);
    }
    return row;
}

